import useAPIError from "@services/useApiError";

export const ErrorMessage = (): JSX.Element => {
    const { error, removeError } = useAPIError();

    const handleDelete = (): void => {
        removeError();
    };

    if (!error) return <></>;

    return (
        <div className="notification is-danger is-light mb-0">
            <button className="delete" onClick={handleDelete}></button>
            {error.message}
        </div>
    );
};
